import { render, staticRenderFns } from "./CarSelector.vue?vue&type=template&id=06c405cc&lang=pug&"
import script from "./CarSelector.vue?vue&type=script&lang=js&"
export * from "./CarSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports